import { colors, fonts } from 'components/styles/variables';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

interface CounterProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  index: number;
  count: number;
}

export default function Counter({
  index,
  count,
  className,
  ...otherProps
}: CounterProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className={`counter ${className}`} {...otherProps}>
      <div className="counter-numbers">
        {t('vdp.counter', {
          index: index + 1,
          count,
        })}
      </div>
      <style jsx>{`
        .counter {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 86px;
          height: 32px;
          flex-shrink: 0;

          background-color: rgba(0, 0, 0, 0.6);
          mix-blend-mode: normal;
          border-radius: 4px;

          font-family: ${fonts.default};
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          letter-spacing: 0.133333px;

          color: ${colors.G1};
        }
      `}</style>
    </div>
  );
}
